import { render, staticRenderFns } from "./wave_monitor.vue?vue&type=template&id=68f2a854&scoped=true&"
import script from "./wave_monitor.vue?vue&type=script&lang=js&"
export * from "./wave_monitor.vue?vue&type=script&lang=js&"
import style0 from "./wave_monitor.vue?vue&type=style&index=0&id=68f2a854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f2a854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68f2a854', component.options)
    } else {
      api.reload('68f2a854', component.options)
    }
    module.hot.accept("./wave_monitor.vue?vue&type=template&id=68f2a854&scoped=true&", function () {
      api.rerender('68f2a854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/monitor/thb/wave_monitor.vue"
export default component.exports